import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import PricingHero from "./components/PricingHero";
import ThreePillars from "./components/ThreePillars";
import Curriculum from "./components/Curriculum";
import EquipmentSupport from "./components/EquipmentSupport";
import LearningSteps from "./components/LearningSteps";
import Pricing from "./components/Pricing";
import Instructors from "./components/Instructors";
import FoundersMessage from "./components/FoundersMessage";
import Testimonials from "./components/Testimonials";
import CTA from "./components/CTA";

export default function Home() {
  return (
    <div className="bg-deepblack min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <PricingHero />
        <ThreePillars />
        <Curriculum />
        <EquipmentSupport />
        <LearningSteps />
        <Instructors />
        <FoundersMessage />
        <Testimonials />
        <Pricing />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}